import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

import { LoggerService } from './app/core/services/logger.service';

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(moduleRef => {
    // Espone il LoggerService globalmente per debugging in console
    const injector = moduleRef.injector;
    const loggerService = injector.get(LoggerService);
    (window as any).agriLogger = loggerService;

    // Mostra info di debug disponibili
    if (!environment.production) {
      console.log('%c🚀 AGRI APP CARICATA - Logger disponibile!', 'color: #3498db; font-weight: bold; font-size: 14px;');
      console.log('%cDigita: %cwindow.agriLogger.showHelp()%c per vedere i comandi disponibili',
        'color: #2ecc71;', 'color: #e74c3c; font-weight: bold;', 'color: #2ecc71;');
    }
  })
  .catch(err => console.error(err));